export const comments_3319767 = {"data":{"data":[],"links":{}}}